import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";

import { db, collection, query, getDocs, orderBy, where } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import TextField from "@mui/material/TextField";
import AdminUsersPartials from "./AdminUsersPartials";
import { useTranslation } from "react-i18next";
import AdminCheck from "./AdminCheck";

const AdminDashboard = () => {
  const { t, i18n } = useTranslation();
  const numOfReviews = 10;
  const [users, setUsers] = useState([]);
  const [allusers, setAllusers] = useState([]);
  const [search, setSearch] = useState(null);

  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    console.log(value);
  };

  console.log("allusers", allusers);

  useEffect(() => {
    setUsers([]);
    setAllusers([]);
    getAdmins();
  }, []);

  const getAdmins = async () => {
    console.log("access db");
    const q = query(collection(db, "users"), where("location", "==", "US"));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      setUsers((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
      setAllusers((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
    });
  };

  const searchUsers = async () => {
    if (search === null || search.length === 0) {
      setUsers(allusers);
    }
    setUsers([]);
    const q = query(
      collection(db, "users"),
      where("firstname", "==", search.trim())
    );

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      console.log(doc);
      setUsers((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
    });
    const q2 = query(
      collection(db, "users"),
      where("lastname", "==", search.trim())
    );

    const querySnapshot2 = await getDocs(q2);
    querySnapshot2.forEach((doc) => {
      console.log(doc);
      setUsers((old) =>
        old.concat({
          ...doc.data(),
          id: doc.id,
        })
      );
    });
  };

  return (
    <Grid container>
      <AdminCheck />
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px" }}>{t("Manage Users2")}</Box>
                {/* <Box className="pink_link" sx={{ cursor: "pointer" }}>
                  Manage Admins
                </Box> */}
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "20px",
                }}
              >
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderRight: 0,
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Users")}
                  <Box sx={{ fontSize: "19px", pt: 2, fontSize: "35px" }}>
                    {allusers?.length}
                  </Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>{" "}
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderRight: 0,
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Users")}
                  <Box sx={{ fontSize: "19px", pt: 2, fontSize: "35px" }}>
                    {allusers?.length}
                  </Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderRight: 0,
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Users")}
                  <Box sx={{ fontSize: "19px", pt: 2, fontSize: "35px" }}>
                    {allusers?.length}
                  </Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Users")}
                  <Box sx={{ fontSize: "19px", pt: 2, fontSize: "35px" }}>
                    {allusers?.length}
                  </Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>
              </Box>
              <Grid container>
                <Grid item md={12} sm={12} xs={12}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      mr: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                      minHeight: "400px",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "15px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>{t("All Users")}</Box>
                      {/* <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        Setting
                      </Box> */}
                    </Box>
                    <Box
                      sx={{
                        py: 2,
                        px: 4,
                      }}
                    >
                      <Box
                        sx={{
                          pb: 3,
                        }}
                      >
                        <Box sx={{ pb: 1, fontSize: "14px", color: "gray" }}>
                          {t("Search a user's first name or last name.")}
                        </Box>
                        <Box sx={{ display: "flex" }}>
                          <TextField
                            value={search}
                            onChange={(e) =>
                              setSearch(e.target.value.toUpperCase())
                            }
                            variant="filled"
                            sx={{ width: "300px" }}
                          />
                          <button
                            className="custom_btn"
                            style={{ width: "100px" }}
                            onClick={searchUsers}
                          >
                            {t("Search")}
                          </button>
                        </Box>
                      </Box>
                      {/* {numOfReviews * (currentPage + 1) < numOfReviews ? (
                        <AdminUsersPartials users={allusers} />
                      ) : (
                        <AdminUsersPartials
                          users={users.slice(
                            currentPage * numOfReviews,
                            numOfReviews * (currentPage + 1)
                          )}
                        />
                      )} */}
                      {numOfReviews * page < numOfReviews ? (
                        <AdminUsersPartials users={allusers} />
                      ) : (
                        <AdminUsersPartials
                          users={users.slice(
                            page - 1 * numOfReviews,
                            numOfReviews * page
                          )}
                        />
                      )}

                      <Pagination
                        count={Math.ceil(users.length / numOfReviews)}
                        variant="outlined"
                        color="secondary"
                        sx={{ my: 2 }}
                        onChange={handleChange}
                        page={page}
                      />

                      {/* <Box sx={{ display: "flex", pt: 5 }}>
                        {Array.apply(null, {
                          length: Math.ceil(users.length / numOfReviews),
                        }).map((e, i) => {
                          if (currentPage === i) {
                            return (
                              <Box
                                key={i}
                                sx={{
                                  border: "1px solid lightgray",
                                  margin: "2px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                  py: 1,
                                  color: "#153a5a",
                                  backgroundColor: "#f5f5f5",
                                }}
                                onClick={(e) => setCurrentPage(i)}
                              >
                                {i + 1}
                              </Box>
                            );
                          } else {
                            return (
                              <Box
                                key={i}
                                sx={{
                                  border: "1px solid lightgray",
                                  margin: "2px",
                                  paddingLeft: "10px",
                                  paddingRight: "10px",
                                  py: 1,
                                  cursor: "pointer",
                                }}
                                onClick={(e) => setCurrentPage(i)}
                              >
                                {i + 1}
                              </Box>
                            );
                          }
                        })}
                      </Box> */}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminDashboard;
// users
